<template>
    <div>
        <el-col
            :span="4"
            style="padding:0;"
        >
            <div class="leftmenu">
                <div
                    class="title"
                    @click="dialogTableVisible=true"
                >
                    <span
                        class="el-icon-refresh"
                        style="float:right;margin:15px 5px 0 0;cursor:pointer;"
                        @click="synStuInfo"
                    >同步信息到设备</span>部门组织

                </div>
                <div
                    class="treepanel"
                    style="height:650px;overflow:auto;"
                >
                    <el-tree
                        ref="classtree"
                        :props="classdefaultProps"
                        :expand-on-click-node="false"
                        :highlight-current="true"
                        @node-click="leftTreeNodeClick"
                        :data="classtreeData"
                        node-key="id"
                        class="combotree"
                    >
                        <span
                            class="custom-tree-node"
                            slot-scope="{ node, data }"
                        >
                            <span
                                class="label-text"
                                :class="{'icon-college': data.type == 2 || data.type == 6, 'icon-department': data.type == 3, 'icon-grade': data.type == 4, 'icon-class': data.type == 5}"
                            >{{node.label}}</span>
                        </span>
                    </el-tree>
                </div>
            </div>
        </el-col>
        <el-col
            :span="20"
            style="padding:0;"
        >
            <div class="righttable">
                <div>
                    <div class="attendanceQuery">
                        <div style="float:right;">
                            <el-input
                                class="input"
                                placeholder="学号、姓名、宿舍查询"
                                v-model="formData.search"
                                style="width:270px;margin-right: 30px;"
                            >
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    @click='searchload'
                                    style="height: 30px;
								    background: rgb(41, 173, 238);
								    color: white;
								    border-bottom-left-radius: 0px;
								    border-top-left-radius: 0px;
								    border-color: rgb(41, 173, 238);
								}"
                                >查询</el-button>
                            </el-input>
                            <el-button
                                type="primary"
                                icon="el-icon-download"
                                @click="exportCheckinList"
                            >导出Excel</el-button>
                        </div>
                        <div style="clear:both;"></div>

                    </div>
                    <div class="attendanceQuery">
                        <el-button @click="Accommodation">批量调宿</el-button>
                        <el-button @click="BatchOccupancy">批量退宿</el-button>
                        <el-button
                            v-if="user.style === K12TYPE"
                            @click="k12ByOccupancy"
                        >清理床位</el-button>
                        <el-form
                            :inline="true"
                            class="demo-form-inline"
                            :model="formData"
                            style="float:right;"
                        >
                            <el-form-item label="楼栋:">
                                <template v-if="role === 'admin' || role === 'logisticsadmin'">
                                    <el-input 
                                        v-model="formData.houseName"
                                        readonly
                                        placeholder="请选择楼栋"
                                        style="cursor:pointer;width: 180px;margin-top:5px;"
                                        suffix-icon="el-icon-arrow-down"
                                        class="wcyc-combotree"
                                        @click.native="buildingUnitSelectShow = !buildingUnitSelectShow"
                                    ></el-input>
                                    <el-tree
                                        v-show="buildingUnitSelectShow"
                                        :props="buildingProps"
                                        :data="buildingData"
                                        :expand-on-click-node="false"
                                        @node-click="builidingTreeNodeHandleClick"
                                        style="width:180px"
                                        class="combotree wcyc-combotree-panel"
                                    >
                                    </el-tree>
                                </template>
                                <el-select
                                    v-if="role === 'housekeeper'"
                                    v-model="formData.houseId"
                                    placeholder="请选择楼栋"
                                    style="width:150px;margin-top:5px;"
                                    @change="builidingTreeComboHandleClick"
                                    :disabled="HouseByManagerUserCombobox.length < 2"
                                >
                                    <el-option
                                        v-for="item in HouseByManagerUserCombobox"
                                        :key="item.houseId"
                                        :label="item.houseName"
                                        :value="item.houseId"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="楼层:">
                                <el-select
                                    v-model="formData.floorId"
                                    placeholder="请先选择楼层"
                                    style="width:150px;margin-top:5px;"
                                    @change="loadData"
                                >
                                    <el-option
                                        key=""
                                        label="全部"
                                        value=""
                                    >
                                    </el-option>
                                    <el-option
                                        v-for="item in floorList"
                                        :key="item.floorId"
                                        :label="item.floorName"
                                        :value="item.floorId"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="性别:"
                                style="margin:0"
                            >
                                <el-select
                                    v-model="formData.sex"
                                    placeholder="请先选择性别"
                                    style="width:120px;margin-top:5px;"
                                    @change="loadData"
                                >
                                    <el-option
                                        key=""
                                        label="全部"
                                        value=""
                                    >
                                    </el-option>
                                    <el-option
                                        key="1"
                                        label="男"
                                        value="1"
                                    >
                                    </el-option>
                                    <el-option
                                        key="2"
                                        label="女"
                                        value="2"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-table
                        border
                        stripe
                        :data="tableData"
                        header-row-class-name="table-header"
                        ref="tableData"
                        :loading="tableload"
                        fit
                        @selection-change="selectchange"
                        @sort-change="tableSortChange"
                    >
                        <el-table-column
                            prop="order"
                            label="序号"
                            width="40"
                            type='selection'
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="index"
                            label="序号"
                            width="40"
                            align="center"
                            type="index"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="studentName"
                            label="姓名"
                            align="center"
                        >
                            <span
                                class="studentname"
                                slot-scope="scope"
                                @click="studentInfoDialog(scope.row.id, $event)"
                            >{{scope.row.studentName}}</span>
                        </el-table-column>
                        <el-table-column
                            prop="studentCode"
                            label="学号"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="sex"
                            label="性别"
                            align="center"
                        >
                            <template slot-scope="scope">
                                {{scope.row.sex==1?"男":"女"}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="departmentParentName"
                            v-if="user.style !== K12TYPE"
                            label="学院"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="departmentName"
                            v-if="user.style !== K12TYPE"
                            label="系部"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="gradeName"
                            label="年级"
                            width="60"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="className"
                            label="班级"
                            align="center"
                            sortable='custom'
                        >
                        </el-table-column>
                        <el-table-column
                            prop="phoneNum"
                            label="联系电话"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="houseName"
                            label="楼栋"
                            align="center"
                            sortable='custom'
                        >
                        </el-table-column>
                        <el-table-column
                            prop="floorName"
                            label="楼层"
                            align="center"
                            width="60"
                            sortable='custom'
                        >
                        </el-table-column>
                        <el-table-column
                            prop="dormitoryName"
                            label="宿舍"
                            align="center"
                            width="60"
                            sortable='custom'
                        >
                        </el-table-column>
                        <el-table-column
                            prop="bedName"
                            label="床位"
                            width="50"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="bedName"
                            label="操作"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <a @click="singleAccommodation(scope.row)">调宿</a>
                                <a @click="singleBatchOccupancy(scope.row)">退宿</a>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-container ">
                        <v-pagination
                            @pageChange="onCurrentChange"
                            :total="total"
                            :isShow="showPagination"
                            :page="page"
                        ></v-pagination>
                    </div>
                </div>
            </div>
        </el-col>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="学生调宿"
            :visible.sync="showRoomEditDialog"
            width="1200px"
            height="660px"
            :before-close="closeDialog"
            left
        >
            <div
                class="autops"
                v-if="showRoomEditDialog"
            >
                <el-row
                    :gutter="20"
                    style="width: 100%;    margin-left: -0px;    margin-right: -10px;"
                >
                    <el-col
                        :span="11"
                        style="padding:0;padding:0;height: 570px;"
                    >
                        <div style="margin-bottom: 10px;">待调宿：（已选
                            <span class="red">{{this.accTableSeldata.length}}</span>人）</div>
                        <el-table
                            border
                            stripe
                            :data="selectiondatadilg"
                            header-row-class-name="table-header"
                            fit
                            @select="checkedSelectiondatafuc"
                            @select-all="checkedSelectiondatafuc"
                            ref="accTableData"
                            @selection-change="accTableSelChange"
                            style="overflow: auto; height: 540px;"
                        >
                            <el-table-column
                                type="selection"
                                width="40"
                                align="center"
                            > </el-table-column>
                            <el-table-column
                                prop="studentName"
                                label="姓名"
                                width="50"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="studentCode"
                                label="学号"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="sex"
                                label="性别"
                                align="center"
                            >
                                <template slot-scope="scope">{{scope.row.sex==1?"男":"女"}}</template>
                            </el-table-column>
                            <el-table-column
                                prop="className"
                                label="班级"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="houseName"
                                label="楼栋"
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="dormitoryName"
                                label="宿舍"
                                align="center"
                            >
                            </el-table-column>
                        </el-table>
                        <div class="pagination-container ">
                            <el-pagination
                                layout="prev, pager, next"
                                :total="innerTotal"
                                v-show="innerTotal > 100"
                                :page-size="innerSize"
                                current-page.sync="innerPage"
                                @current-change="innerPageChange"
                            ></el-pagination>
                        </div>
                    </el-col>

                    <el-col
                        :span="2"
                        style="width: 7.33333%;text-align:center;"
                    >
                        <div>
                            <a @click="qianru">
                                <img
                                    src="../../../static/images/bathocco/ruzhu.png"
                                    style="margin-top:180px;"
                                >
                                <p>迁入</P>
                            </a>
                            <a @click="duidiao">
                                <img
                                    src="../../../static/images/bathocco/changeover.png"
                                    style="margin-top:32px;"
                                >
                                <p>对调</P>
                            </a>
                            <el-button
                                @click="wanchengqianru"
                                style="margin-top:32px;"
                            >完成</el-button>
                        </div>
                    </el-col>
                    <el-col
                        :span="12"
                        style="width:46.83333%;padding:0;border:1px dashed #cccccc; height: 570px;"
                    >

                        <el-form
                            :inline="true"
                            class="demo-form-inline"
                            :model="accformData"
                            @selection-change="checkedSelectiondatafuc"
                        >
                            <el-form-item
                                label="学号:"
                                style="width:29%;margin-left: 10px;"
                            >
                                <el-input
                                    v-model="accformData.studentCode"
                                    placeholder="请输入学号"
                                    style="width: 110px"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                v-if="role==='admin' || role === 'logisticsadmin'"
                                label="楼栋:"
                                style="width:28%"
                            >
                                <el-select
                                    v-model="accformData.houseId"
                                    placeholder="请选择"
                                    style="width:105px"
                                >
                                    <el-option
                                        v-for="item in building"
                                        :key="item.houseId"
                                        :label="item.houseName"
                                        :value="item.houseId"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="width:39%">
                                <el-input
                                    class="input"
                                    placeholder="请输入宿舍名查询"
                                    v-model="accformData.dormitoryName"
                                >
                                    <el-button
                                        slot="append"
                                        icon="el-icon-search"
                                        @click='searchstudentbysuse'
                                        style="padding: 0 9px;"
                                    >查询</el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div class="xzsu">选择宿舍：(剩余
                            <span class="red">{{emptyBed}}</span>床位)</div>

                        <div style="text-align:center;">
                            <el-table
                                border
                                stripe
                                :data="susetableData"
                                header-row-class-name="table-header"
                                fit
                            >
                                <el-table-column
                                    prop="studentName"
                                    label="姓名"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="studentCode"
                                    label="学号"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="sex"
                                    label="性别"
                                    align="center"
                                >
                                    <template slot-scope="scope">{{scope.row.sex==1?"男":"女"}}</template>
                                </el-table-column>
                                <el-table-column
                                    prop="className"
                                    label="班级"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="houseName"
                                    label="楼栋"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="dormitoryName"
                                    label="宿舍"
                                    align="center"
                                >
                                </el-table-column>
                            </el-table>

                            <div style='clear:both;'></div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="showClose"
            title="批量退宿"
            :visible.sync="showAutoPro"
            width="550px"
            height="330px"
            left
            :before-close="closeDialog"
        >
            <div style="width:520px;height:300px;text-align: center">
                <div style="margin-top:61px">
                    <span
                        class="el-icon-warning"
                        style="color: #FD8C25;font-size: 45px;"
                    ></span>
                </div>
                <!--<div style="margin-top:24px;color:#26aef3;font-size: 12px">-->
                <!--{{autoPer}}%-->
                <!--</div>-->
                <div style="margin-top: 24px;">
                    <el-progress
                        :text-inside="true"
                        :stroke-width="16"
                        :percentage="autoPer"
                        status="success"
                    ></el-progress>
                </div>
                <div style="text-align: center;margin-top: 20px;font-size: 16px;color: #666666;">{{processMsg}}</div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import Api from "@/api";
import axios from "axios";
import basetable from "@/mixins/base-table";
import Accommodation from "@/components/Accommodation/index.vue";
import { session } from "@/util";
import { mapState } from 'vuex';

export default {
    mixins: [basetable],
    data () {
        let user = session("user");
        return {
            user: user,
            role: user.tsr.roleCode,
            innerPage: 1,
            innerSize: 100,
            innerTotal: 0,
            houseName: "",
            nodekey: "",
            schoolId: "",
            schoolNum: "",
            tableload: false,
            doNotInit: true,
            buildingData: null,
            buildingProps: {
                label: "lable",
                children: "children",
                isLeaf: "leaf"
            },
            buildingUnitSelectShow: false,
            emptyBed: 0,
            formData: {
                houseName: "",
                houseId: "", // 楼栋
                floorId: "", // 楼层
                sex: "",
                search: "",
                classSort: null,
                houseSort: null,
                dormitorySort: null,
                floorSort: null
            },
            accformData: {
                houseName: "",
                houseId: "", // 楼栋
                dormitoryName: "",
                studentCode: ""
            },
            susetableData: [],
            selectiondatadilg: [],
            building: [],
            floorList: [],
            selectiondata: [],
            showBatchOccupancyDialog: false,
            showRoomEditDialog: false,
            tableData: [],
            classtreeData: [],
            classdefaultProps: {
                label: "directorName",
                isLeaf: "leaf",
                children: "nextLevels"
            },
            checkedSelectiondata: [],
            studentListA: [],
            dormitoryIdA: "",
            dormitoryIdB: "",
            seartchkey: "",
            changenode: null,
            HouseByManagerUserCombobox: [], // 宿管员楼栋下拉
            currentStudentInfo: null,
            studentDomTarget: null,
            accTableSeldata: [],
            // 进度条
            lunxunrequesttimer: null,
            showAutoPro: false,
            autoPer: 0,
            showClose: false,
            processMsg: '',

        };
    },
    computed: {
        ...mapState([
            'K12TYPE',
            'UNK12TYPE'
        ])
    },
    watch: {},
    methods: {
        k12ByOccupancy () {
            let html = `<div style="width:400px;padding:30px 50px;">
                            <div style="margin-bottom:20px;text-align:center"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>学籍失效的学生（删除、毕业等情况）的床位将会被全部清理。</p>
							<p>确认进行清理床位吗？</p>
						</div>`;
            this.$alert(html, "提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                showCancelButton: true
            })
                .then(() => {
                    let timer, loading;
                    const requestStatus = () => {
                        Api.AccommodationManagement.checkCleanK12Stu().then(res => {
                            if (res.code == 0 && res.data) {
                                clearTimeout(timer);
                                this.timer = null;
                                loading.close();
                                this.$message({
                                    type: 'success',
                                    message: '清理床位成功！',
                                    showClose: true
                                })
                                this.loadData();
                            } else {
                                timer = setTimeout(() => {
                                    requestStatus()
                                }, 500);
                            }
                        }).catch(() => {
                            this.lunxunrequesttimer = null;
                            loading.close();
                            this.$message('清理床位失败!');
                        })
                    }

                    Api.AccommodationManagement.cleanK12BiyeStuRoom().then(res => {
                        if (res.code === 0) {
                            loading = this.$loading({
                                lock: true,
                                text: '正在清理床位，请稍候...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            })
                            requestStatus();
                        } else {
                            this.$message('清理床位失败，请稍后重试！');
                        }
                    })
                }).catch(() => {

                });

        },
        // 点击查看学生资料
        studentInfoDialog (studentId, event) {
            Api.attendanceQuery
                .getcurrentStudentInfo("userId=" + studentId)
                .then(res => {
                    if (res.code === 0) {
                        let image = res.data.image;
                        if (image) {
                            image = image
                                ? "/suguan/oss/d/" +
                                image +
                                "?token=" +
                                session("token").accesstoken
                                : "";
                        }
                        this.currentStudentInfo = {
                            name: res.data.student_name,
                            studentCode: res.data.student_code,
                            gender: res.data.sex,
                            bornDate: res.data.birthdate,
                            nation: res.data.nation,
                            cName: res.data.class_Name,
                            phoneNum: res.data.phone_num,
                            inDate: res.data.in_time,
                            image: image
                        };
                        this.studentDomTarget = event.target;
                        this.$emit(
                            "getcurrentStudentInfo",
                            this.currentStudentInfo,
                            this.studentDomTarget
                        );
                    } else {
                        this.showTip(res.message, 'info');
                    }
                });
        },
        getFloorListByHouseId (id) {
            Api.attendanceQuery.getFloorListByHouseId(id).then(res => {
                if (res.code == 0) {
                    this.floorList = res.data;
                }
            });
        },
        builidingTreeNodeHandleClick (data, node) {
            if (node.level == 3) {
                this.formData.houseId = data.id;
                this.formData.houseName = data.lable;
                // 关闭选择器
                this.buildingUnitSelectShow = false;
                this.getFloorListByHouseId(data.id);
                this.loadData();
            }
        },
        builidingTreeComboHandleClick (v) {
            this.formData.houseName = v;
            this.getFloorListByHouseId(this.formData.houseId);
            this.loadData();
        },
        wanchengqianru () {
            this.showRoomEditDialog = false;
            // 关闭后刷表
            if (this.changenode) {
                this.classhandleCheckChange(this.changenode);
            }
        },
        checkedSelectiondatafuc (selection) {
            this.checkedSelectiondata = selection;
        },
        duidiao () {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
							<p>宿舍对调操作会将两个宿舍所有学生进行对调，</p>
							<p>确认进行此操作吗？</p>
						</div>`;
            this.$alert(html, "提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                showCancelButton: true
            })
                .then(_ => {
                    let dormitoryIds = [];
                    this.accTableSeldata.forEach(element => {
                        dormitoryIds.push(element.dormitoryId);
                    });
                    dormitoryIds = this.dedupe(dormitoryIds);
                    if (this.dormitoryIdB === '' || this.dormitoryIdB === undefined) {
                        this.$message("请选择目标宿舍!");
                        return;
                    }
                    if (dormitoryIds.length === 0) {
                        this.$message("请选择对调宿舍!");
                        return;
                    }
                    if (dormitoryIds.length > 1) {
                        this.$message("仅支持两两宿舍对调，请重新选择！");
                        return;
                    } else {
                        if (this.dormitoryIdB == this.dormitoryIdA) {
                            this.$message("目标寝室和对调寝室是同一寝室，请重新选择!");
                            return;
                        }
                        var houseId;
                        // 宿管员时building不加载
                        if (this.building.length > 0) {
                            var houseIds = this.building.filter(
                                x => this.accTableSeldata[0].houseName == x.houseName
                            );
                            houseId = houseIds[0].houseId;
                        } else {
                            houseId = this.formData.houseId;
                        }

                        let data = {
                            dormitoryIdA: dormitoryIds[0],
                            dormitoryIdB: this.dormitoryIdB,
                            type: "2"
                        };
                        Api.AccommodationManagement.batchAdjustBed(data).then(res => {
                            if (res.code == 0) {
                                this.$message("对调成功！！！");
                                // let A = Object.assign({}, this.dormitoryIdA);
                                // let B = Object.assign({}, this.dormitoryIdB);
                                //  this.dormitoryIdB = A;
                                // this.dormitoryIdA = B;
                                // [this.dormitoryIdB, this.dormitoryIdA] = [this.dormitoryIdA, this.dormitoryIdB]

                                let str = "";
                                str = `houseId=${this.susetableData[0].houseId}&dormitoryName=${this.susetableData[0].dormitoryName}`;

                                Api.AccommodationManagement.adjustBedTargetDormitory(
                                    str,
                                    this.page,
                                    90000
                                ).then(res => {
                                    if (res.code == 0) {
                                        this.susetableData = res.data.studentList;
                                        this.emptyBed = res.data.emptyBed;
                                    } else {
                                        this.$message(res.message);
                                    }
                                });
                                let sksksstr =
                                    "&houseId=" +
                                    houseId +
                                    "&dormitoryName=" +
                                    this.selectiondatadilg[0].dormitoryName;

                                Api.AccommodationManagement.adjustBedTargetDormitory(
                                    sksksstr,
                                    this.page,
                                    90000
                                ).then(res => {
                                    if (res.code == 0) {
                                        if (res.data) {
                                            this.selectiondatadilg = res.data.studentList;
                                        } else {
                                            this.selectiondatadilg = res.data;
                                        }
                                    } else {
                                        this.$message(res.message);
                                    }
                                });
                            } else {
                                this.$message(res.message);
                            }
                        });
                    }
                })
                .catch(_ => { });


        },
        qianru () {
            if (this.accTableSeldata.length > 0) {
                if (this.accTableSeldata.length > this.emptyBed) {
                    this.$message("目标宿舍床位不足，请重新选择！");
                } else {
                    for (
                        let index = 0;
                        index < this.accTableSeldata.length;
                        index++
                    ) {
                        const element = this.accTableSeldata[index];
                        this.selectiondatadilg.splice(
                            this.selectiondatadilg.indexOf(element),
                            1
                        );

                        if (this.susetableData.indexOf(element) == -1) {
                            this.susetableData.push(element);
                            this.susetableData = this.dedupe(this.susetableData);
                            this.studentListA.push(element.id);
                        }
                    }

                    if (this.studentListA.length > 0) {
                        let data = {
                            dormitoryIdA: this.dormitoryIdA,
                            dormitoryIdB: this.dormitoryIdB,
                            studentListA: this.studentListA,
                            type: "1"
                        };

                        Api.AccommodationManagement.batchAdjustBed(data).then(res => {
                            if (res.code == 0) {
                                this.accTableSeldata = [];
                                this.studentListA = [];
                                this.$message("迁入成功！！！");
                                this.emptyBed = this.emptyBed - this.studentListA.length;
                                this.searchstudentbysuse();
                            } else {
                                this.$message(res.message);
                            }
                        });
                    }
                }
            } else {
                this.$message("未选择学生！！！");
            }
        },
        dedupe (array) {
            return Array.from(new Set(array));
        },
        searchstudentbysuse () {
            if (this.accformData.studentCode === '') {
                if (this.accformData.dormitoryName === '') {
                    this.$message('学号和宿舍名至少填写一个!');
                    return;
                }
                if (this.accformData.houseId === '' || this.accformData.houseId === undefined || this.accformData.houseId === null) {
                    this.$message('请选择楼栋！！');
                    return;
                }
            }

            let str = "";
            if (this.accformData.studentCode) {
                str += "studentCode=" + this.accformData.studentCode;
            }
            if (this.accformData.houseId) {
                str += "&houseId=" + this.accformData.houseId;
            }
            if (this.accformData.dormitoryName) {
                str += "&dormitoryName=" + this.accformData.dormitoryName;
            }
            Api.AccommodationManagement.adjustBedTargetDormitory(
                str,
                this.page,
                90000
            ).then(res => {
                if (res.code == 0) {
                    this.dormitoryIdB = res.data.dormitoryId;
                    this.emptyBed = res.data.emptyBed;
                    this.susetableData = res.data.studentList;
                } else {
                    this.$message(res.message);
                }
            });
        },
        submitForm () { },
        selectchange (selection, row) {
            this.selectiondata = selection;
        },
        cancelFormEdit (dialog, form) {
            this[dialog] = false;
            // this.$refs[form].resetFields();
        },
        comfirmRoomEdit () {
            this.$refs.roomEditForm.validate((valid, obj) => {
                if (valid) {
                    this.showRoomEditDialog = false;
                } else {
                    this.$message("请按要求填写完成后再提交！");
                    return false;
                }
            });
        },
        accTableSelChange (selections) {
            this.accTableSeldata = selections;
        },
        leftTreeNodeClick (data, node) {
            this.formData.search = '';
            this.classhandleCheckChange(data, true);
            this.loadDataInFirstPate();
        },
        classhandleCheckChange (Node, doNotLoad) {
            this.changenode = Node;
            this.nodekey = "";
            let id = Node.relId;
            switch (Node.type) {
                case '2':
                    this.nodekey = "departmentId=" + id;
                    break;
                case '3':
                    this.nodekey = "departmentId=" + id;
                    break; 
                case '4':
                    this.nodekey = "gradeId=" + id;
                    if(this.$refs.classtree.getNode(Node.parentId).data.type == 6) {
                        this.nodekey += "&schoolNum=" +this.$refs.classtree.getNode(Node.parentId).data.relId;
                    } else {
                        this.nodekey = "";
                    }
                    break;
                case '5':
                    this.nodekey = "classId=" + id;
                    break;
                case '6':
                    this.nodekey = "schoolNum=" + id;
                    break;
                default:
                    break;
            }
            this.schoolId = Node.schoolId;
            this.schoolNum = Node.schoolNum;

            let dto = {
                classId: 0,
                departmentId: 0,
                departmentIdList: [0],
                dormitoryCode: "",
                dormitoryId: 0,
                floorId: this.formData.floorId ? this.formData.floorId : 0,
                gradeId: 0,
                houseId: this.formData.houseId ? this.formData.houseId : 0,
                pageNum: 1,
                pageSize: 99999999,
                schoolId: Node.schoolId,
                schoolNum: Node.schoolNum,
                search: this.formData.search ? this.formData.search : "",
                // "search": '',
                sex: this.formData.sex,
                studentCode: "",
                userId: 0
            };

            this.dto = dto;
            if (!doNotLoad) {
                this.loadData();
            }
        },
        loadDataInFirstPate () {
            this.page === 1 ? this.loadData() : this.page = 1;
        },
        searchload () {
            this.classhandleCheckChange(this.changenode);
        },
        innerPageChange (page) {
            this.innerPage = page;
            return this.loadInnerTable();
        },
        loadInnerTable () {
            let key = "";
            if (this.nodekey) {
                key += this.nodekey;
            }
            if (this.schoolNum) {
                key += "&schoolNum=" + this.schoolNum;
            }
            if (this.formData.sex) {
                key += "&sex=" + this.formData.sex;
            }
            if (this.formData.houseId) {
                key += "&houseId=" + this.formData.houseId;
            }
            if (this.formData.floorId) {
                key += "&floorId=" + this.formData.floorId;
            }
            if (this.formData.search) {
                key += "&search=" + this.formData.search;
            }

            // this.HouseByManagerUserCombobox.forEach((item) => {
            //     key += '&houseIdList=' + item.houseId;
            // })
            // 宿舍管理员只能查自己楼栋
            if (this.user.tsr.roleName === "housekeeper") {
                let list = this.HouseByManagerUserCombobox.map(item => {
                    return item.houseId;
                });
                key += "&houseIdList=" + list.join("%2c");
            }
            // schoolId必填
            key += "&schoolId=" + this.user.schoolId;
            this.seartchkey = key;

            return Api.AccommodationManagement.getCheckinList(
                this.seartchkey,
                this.innerPage,
                this.innerSize
            ).then(res => {
                if (res.code == 0) {
                    this.selectiondatadilg = res.data.list;
                    this.innerTotal = res.data.total;
                    this.$refs.accTableData &&
                        this.$refs.accTableData.toggleAllSelection();
                } else {
                    this.$message(res.message);
                }
            });
        },
        tableSortChange (columnObj) {
            this.formData.classSort = null;
            this.formData.floorSort = null;
            this.formData.houseSort = null;
            this.formData.dormitorySort = null;
            if (columnObj.order) {
                var order = columnObj.order === 'descending' ? columnObj.order.substring(0, 4) : columnObj.order.substring(0, 3);
                var prop;
                switch (columnObj.prop) {
                    case 'dormitoryName':
                        prop = 'dormitorySort';
                        break;
                    case 'houseName':
                        prop = 'houseSort';
                        break;
                    case 'floorName':
                        prop = 'floorSort';
                        break;
                    case 'className':
                        prop = 'classSort';
                        break;
                }
                this.formData[prop] = order;
            }
            this.classhandleCheckChange(this.changenode);


        },
        startBatchProcess (key) {
            this.showAutoPro = true;
            this.processMsg = '正在批量退宿,请勿关闭当前页面!';
            let lunxunrequest = (key) => {
                return Api.AccommodationManagement.getBatchCheckOutProcess(key).then(res => {
                    if (res.code === 0 && res.data !== null) {
                        this.autoPer = parseInt(res.data);
                        if (this.autoPer === 100) {
                            this.endBatchProess()
                            this.classhandleCheckChange(this.changenode);
                        } else {
                            this.lunxunrequesttimer = setTimeout(() => {
                                lunxunrequest(key);
                            }, 1000)
                        }
                        return this.autoPer;
                    } else {
                        this.$message(res.message);
                        this.showClose = true;
                    }
                });
            }

            this.showRoomEditDialog = false;
            lunxunrequest(key);
        },
        endBatchProess () {
            clearTimeout(this.lunxunrequesttimer);
            this.lunxunrequesttimer = null;
            this.showAutoPro = false;
        },
        loadData () {
            let key = "";
            if (this.nodekey) {
                key += this.nodekey;
            }
            if (this.schoolNum) {
                key += "&schoolNum=" + this.schoolNum;
            }
            if (this.formData.sex) {
                key += "&sex=" + this.formData.sex;
            }
            if (this.formData.houseId) {
                key += "&houseId=" + this.formData.houseId;
            }
            if (this.formData.floorId) {
                key += "&floorId=" + this.formData.floorId;
            }
            if (this.formData.search) {
                key += "&search=" + this.formData.search;
            }
            if (this.formData.dormitorySort) {
                key += '&dormitorySort=' + this.formData.dormitorySort;
            }
            if (this.formData.houseSort) {
                key += '&houseSort=' + this.formData.houseSort;
            }
            if (this.formData.floorSort) {
                key += '&floorSort=' + this.formData.floorSort;
            }
            if (this.formData.classSort) {
                key += '&classSort=' + this.formData.classSort;
            }

            // 宿舍管理员只能查自己楼栋
            if (this.user.tsr.roleName === "housekeeper") {
                let list = this.HouseByManagerUserCombobox.map(item => {
                    return item.houseId;
                });
                key += "&houseIdList=" + list.join("%2c");
            }
            // schoolId必填
            key += "&schoolId=" + this.user.schoolId;
            this.seartchkey = key;
            return Api.AccommodationManagement.getCheckinList(
                this.seartchkey,
                this.page,
                this.size
            ).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                } else {
                    this.$message(res.message);
                }
            });
        },
        queryHouseByManagerUser () {
            return Api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                } else {
                    this.$message(res.message);
                }
            });
        },
        closeDialog (done) {
            this.wanchengqianru();
            done();
        },
        querySchoolRelationTree () {
            let user = session("user");
            return Api.common.querySchoolRelationTree(user.schoolId).then(res => {
                // let treedata = [];
                // treedata.push(res.data);
                this.classtreeData = res.data;
            });
        },
        getSchoolCapmusHouselist (item) {
            return new Promise(function (resolve, reject) {
                let user = session("user");
                Api.summary.getAllHouseBySchool(user.schoolId, "").then(res => {
                    if (res.code == 0) {
                        resolve(res);
                    } else {
                        reject(res);
                    }
                });
            });
        },
        singleAccommodation (item) {
            this.dormitoryIdB = "";
            this.accformData = {
                houseName: "",
                houseId: "", // 楼栋
                dormitoryName: "",
                studentCode: ""
            };
            // 宿管员保留ID查楼层
            if (this.role === "housekeeper") {
                this.accformData.houseId = this.formData.houseId;
            } else if (this.role === "admin" || this.role === 'logisticsadmin') {
                let promiseCapmus = this.getSchoolCapmusHouselist();
                promiseCapmus.then(res => {
                    if (res.code == 0) {
                        this.building = res.data;
                    }
                });
            }
            this.studentListA = [];
            this.emptyBed = 0;
            this.susetableData = [];
            this.dormitoryIdA = Number(item.dormitoryId);
            this.showRoomEditDialog = true;
            this.$nextTick(() => {
                this.$refs.accTableData.toggleAllSelection();
            });
            (this.selectiondatadilg = []), this.selectiondatadilg.push(item);
        },
        Accommodation () {
            var selectiondata;
            this.accformData = {
                houseName: "",
                houseId: "", // 楼栋
                dormitoryName: "",
                studentCode: ""
            };
            let accommondationHandle = selectiondata => {
                //   if (this.selectiondata.length > 0) {
                this.dormitoryIdB = "";
                this.studentListA = [];
                this.emptyBed = 0;
                this.susetableData = [];
                this.selectiondatadilg = Object.assign([], selectiondata);
                this.dormitoryIdA = Number(selectiondata[0].dormitoryId);
                this.showRoomEditDialog = true;
                this.$nextTick(() => {
                    this.$refs.accTableData.toggleAllSelection();
                });
                if (this.role === "housekeeper") {
                    this.accformData.houseId = this.formData.houseId;
                } else if (this.role === "admin" || this.role === 'logisticsadmin') {
                    let promiseCapmus = this.getSchoolCapmusHouselist();
                    promiseCapmus.then(res => {
                        if (res.code == 0) {
                            this.building = res.data;
                        }
                    });
                }
                //   }
            };
            if (parseInt(this.changenode.type) < 4 && this.selectiondata.length === 0) {
                this.$message('批量调宿只能对年级或班级操作！');
                return;
            }
            if (this.selectiondata.length > 0) {
                selectiondata = this.selectiondata;
                this.innerTotal = selectiondata.length;
                accommondationHandle(selectiondata);
            } else {
                if (this.changenode) {
                    this.innerPage = 1;
                    this.loadInnerTable().then(() => {
                        if (this.selectiondatadilg.length === 0) {
                            $.$message("该部门组织下无已入住学生");
                            return;
                        }
                        selectiondata = this.selectiondatadilg;
                        accommondationHandle(selectiondata);
                    });
                } else {
                    this.$message("请先选择部门节点!!");
                }
            }
        },

        downloads (data) {
            if (!data) {
                return;
            }
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "学生住宿查询.xls");
            document.body.appendChild(link);
            link.click();
        },
        exportCheckinList () {
            // window.open('/exportData/exportCheckinList?' + str);
            Api.systemConfig
                .exportCheckinList(this.seartchkey, this.page, 999999)
                .then(res => {
                    if (res.code == 0) {

                        let arr = res.data;
                        for (var key in arr) {
                            this.$common.globalExportExl(key, arr[key], '学生住宿查询列表');



                        }
                    }


                });
        },

        singleBatchOccupancy (item) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
							<p>确认将所选中的人员退宿吗？</p>
							<p>退宿不会删除该学生信息。</p>
						</div>`;
            this.$alert(html, "确认退宿?", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定退宿",
                showCancelButton: true
            })
                .then(_ => {
                    Api.systemConfig
                        .singleCheckOut(item.id, item.dormitoryId)
                        .then(res => {
                            if (res.code == 0) {
                                this.$message("退宿成功");
                                this.loadData();
                            } else {
                                this.$message(res.message);
                            }
                        });
                })
                .catch(_ => { });
        },
        BatchOccupancy () {
            let selectiondata;
            let BatchOccupancyCallback = (selectiondata) => {
                let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
							<p>确认将所选中的人员退宿吗？</p>
							<p>退宿不会删除该学生信息。</p>
                        </div>`;

                this.$alert(html, "确认退宿?", {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定退宿",
                    showCancelButton: true
                })
                    .then(_ => {
                        let data = {};
                        if (selectiondata) {
                            data = {
                                dormitoryIdList: selectiondata.map(function (v) {
                                    return v.dormitoryId;
                                }),
                                schoolId: selectiondata.map(function (v) {
                                    return v.schoolId;
                                })[0],
                                schoolNum: selectiondata.map(function (v) {
                                    return v.schoolNum;
                                })[0],
                                studentIdList: selectiondata.map(function (v) {
                                    return v.id;
                                })
                            };
                            data.batchType = 1;

                        } else {
                            if (this.changenode.type === '4') {
                                data.gradeId = this.changenode.relId;
                            }
                            if (this.changenode.type === '5') {
                                data.classId = this.changenode.relId;
                            }
                            data.batchType = 2;
                        }
                        Api.systemConfig.batchCheckOut(data).then(res => {
                            if (res.code == 0) {
                                this.startBatchProcess(res.data);
                            } else {
                                this.$message(res.message);
                            }
                        });
                    })
                    .catch(_ => { });
            };
            if (this.changenode.type < 4 && this.selectiondata.length === 0) {
                this.$message('批量退宿只能对年级或班级操作！');
                return;
            }
            if (this.selectiondata.length > 0) {
                selectiondata = this.selectiondata;
                BatchOccupancyCallback(selectiondata);
            } else {
                if (this.changenode) {
                    BatchOccupancyCallback();
                    // let key =
                    //     this.nodekey +
                    //     `&schoolId=${this.schoolId}&schoolNum=${this.schoolNum}`;
                    // Api.AccommodationManagement.getCheckinList(key, 1, 99999).then(
                    //     res => {
                    //         if (res.code == 0) {
                    //             if (res.data.list.length === 0) {
                    //                 this.$message("当前选中的部门组织下没有入住学生");
                    //                 return;
                    //             }
                    //             selectiondata = res.data.list;
                    //             BatchOccupancyCallback(selectiondata)
                    //         } else {
                    //             this.$layer.msg(res.message);
                    //         }
                    //     }
                    // );
                } else {
                    this.$message("请先选中节点!!");
                    return;
                }
            }

        },
        handleNodeClick (node) {
            if (node.directorLevel == 0) {
                this.searchDirector = "directorId=" + node.id;
            } else {
                this.searchDirector = "poindId=" + node.id;
            }
            this.loadData();
        },
        loadNode (node, resolve) {
            let searchvision = this.searchvision;
            if (searchvision) {
                searchvision = searchvision.split("=");
                if (node.level !== 0) {
                    // 根据父节点id找寻下一级的所有节点
                    let searchStr = "";
                    if (searchvision[1]) {
                        searchStr += "bookVersionId=" + searchvision[1];
                    }

                    if (node.id != null || node.id != "") {
                        searchStr += "&parentId=" + node.data.id;
                    }

                    Api.resourse.getBookDirector(searchStr).then(res => {
                        if (res) {
                            if (res.data == null) {
                                resolve([]);
                            } else {
                                resolve(res.data);
                            }
                        }
                    });
                }
            }
        },
        synStuInfo () {
            this.processMsg = '正在同步信息到设备,请勿关闭当前页面!';
            let html = `<div style="width:400px;height:128px;padding:20px 50px;text-align: center">
                        <div style=""><span class="el-icon-question" style="color: #FD8C25;font-size: 50px;"></span> </div>
                        <p>同步信息到设备预计耗时较长，请耐心等待!</p>
                    </div>`;

            this.$alert(html, '同步信息到设备', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定同步',
                showCancelButton: true
            }).then(() => {

                Api.AccommodationManagement.againSendStudentToHKVS().then((res) => {
                    if (res.code === 0) {
                        this.showAutoPro = true;
                        var key = res.data;
                        let lunxunrequest = (key) => {
                            return Api.AccommodationManagement.getAgainSendStudentToHKVSProcess(key).then(res => {
                                if (res.code === 0 && res.data !== null) {
                                    this.autoPer = parseInt(res.data);
                                    if (this.autoPer === 100) {
                                        this.showAutoPro = false;
                                        this.showTip("同步成功");
                                        clearTimeout(this.lunxunrequesttimer);
                                    } else {
                                        this.lunxunrequesttimer = setTimeout(() => {
                                            lunxunrequest(key);
                                        }, 1000)
                                    }
                                    return this.autoPer;
                                } else {
                                    this.showTip(res.message, "error");
                                    this.showClose = true;
                                }
                            });
                        }

                        this.showRoomEditDialog = false;
                        lunxunrequest(key);

                    } else {
                        this.showTip(res.message, "error");
                    }
                }).finally(this.closeLoading);

            })


        }
    },
    mounted () {
        let user = session("user");
        Api.common.querySchoolHouseTree(user.schoolId).then(res => {
            if (res.code == 0) {
                this.buildingData = res.data.treeDTOList;

                // if(this.$refs.classtree.getCurrentNode()) {
                // 	let node = this.$refs.classtree.getCurrentNode();
                // 	this.classhandleCheckChange(node);
                // }
                this.queryHouseByManagerUser().then(() => {
                    if (this.role === "housekeeper") {
                        this.formData.houseId = this.HouseByManagerUserCombobox[0].houseId;
                        this.formData.houseName = this.HouseByManagerUserCombobox[0].houseName;
                        this.getFloorListByHouseId(this.formData.houseId);
                    }
                    this.loadData();
                });
            } else {
                this.$message(res.message);
            }
        });
        this.querySchoolRelationTree().then(() => {
            this.changenode = this.classtreeData[0];
            this.$refs.classtree.setCurrentKey(this.changenode.id);
            this.schoolId = this.changenode.schoolId;
            this.schoolNum = this.changenode.schoolNum;
        });
    },
    created () { }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.attendanceQuery {
    padding-top: 20px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    border-bottom: 1px solid #ccc;
    .el-form-item {
        height: 50px;
        margin-bottom: 10px;
        margin-right: 20px;
        font-size: 12x;
        .el-form-item__label {
            color: #666;
        }
        .el-input {
            width: auto;
        }
        .el-input__inner {
            padding: 0px 10px;
            margin-top: 12px;
        }
        .combotree {
            position: absolute;
            left: 0;
            top: 42px;
            z-index: 19920104;
            overflow: auto;
            height: 300px;
            min-width: 170px;
        }
    }
}

.el-form-item__content {
    line-height: 50px;
    position: relative;
    font-size: 14px;
}

.leftmenu {
    width: 100%;
    display: block;
    margin-top: 20px;
    border: 1px solid #cccccc;
    background: white;
    .title {
        width: 100%;
        background: #25aef4;
        font-size: 12px;
        color: white;
        line-height: 40px;
        height: 40px;
        position: relative;
        text-indent: 1em;
        .res-booklist {
            position: absolute;
            width: 100%;
            height: 200px;
            overflow-y: auto;
            background: #fff;
            top: 43px;
            left: 0;
        }
    }
    .treepanel {
        width: 100%;
    }
}

.righttable {
    margin-top: 20px;
    padding: 10px 20px;
    min-height: 690px;
    background: white;
}

.xzsu {
    height: 36px;
    line-height: 36px;
    background-color: #f7f7f7;
    padding: 0 5px 0 10px;
    .input {
        width: 300px;
        float: right;
        margin-top: 2px;
        .el-input__inner {
            border: 1px solid #26aef3;
            border-right: none;
        }
    }
}
.studentname {
    color: #26aef3;
    cursor: pointer;
}
.red {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/accommodationManagement/accommodationQuery.vue